import { Prescription } from '../../interfaces/prescription';
import { PrescriptionCompletedPayload } from './types/prescription-completed-payload';
import { PrescriptionSentPayload } from './types/prescription-sent-payload';
import { CERTIFICATES } from '../../containers/certificate/certificates';

export interface BuildPrescriptionSentOptions {
  /** Payload base do prescription_completed já construído */
  completedPayload: PrescriptionCompletedPayload;
  /** Prescrição atualizada retornada pela API */
  prescription: Prescription;
  /** Se a impressão (PDF) foi habilitada */
  generatePdf: boolean;
  /** Tipo de certificado selecionado */
  certificateType: CERTIFICATES | null;
  /** Se a data deve ser exibida no PDF */
  showDateInPdf: boolean;
  /** Data de emissão selecionada */
  emittedTo: Date | null;
  /** Se deve emitir em páginas separadas */
  issueMedicinesInSeparateTabs: boolean;
  /** Email de envio */
  email: string;
  /** Se o parceiro tem certificado digital obrigatório */
  isDigitalSignMandatory: boolean;
  /** Se o PDF é customizado (logo/cores personalizadas) */
  isPdfCustomized: boolean;
  /** Se emitiu prescrição do número pessoal */
  isPersonalNumberSent: boolean;
  /** Se o endereço do paciente foi solicitado/preenchido */
  hasAddressRequired: boolean;
}

/**
 * Constrói o payload do evento `prescription_sent` a partir dos dados
 * disponíveis no momento da emissão.
 */
export function buildPrescriptionSentPayload(options: BuildPrescriptionSentOptions): PrescriptionSentPayload {
  const {
    completedPayload,
    prescription,
    generatePdf,
    certificateType,
    showDateInPdf,
    emittedTo,
    issueMedicinesInSeparateTabs,
    email,
    isDigitalSignMandatory,
    isPdfCustomized,
    isPersonalNumberSent,
    hasAddressRequired,
  } = options;

  const isDigitalSigned = !!certificateType
    && certificateType !== CERTIFICATES.MANUAL
    && certificateType !== CERTIFICATES.NOT_DEFINED;

  const digitalCertificate = isDigitalSigned && certificateType ? certificateType : '';

  return {
    ...completedPayload,
    is_printed: generatePdf,
    validation_code: prescription.CodigoValidacao ?? '',
    is_digital_signed: isDigitalSigned,
    digital_certificate: digitalCertificate,
    has_prescription_date: showDateInPdf,
    issued_on_separate_pages: issueMedicinesInSeparateTabs,
    has_address_required: hasAddressRequired,
    issue_date: emittedTo ? emittedTo.toISOString() : '',
    is_sent_by_email: !!email,
    establishment_name: prescription.Estabelecimento?.Nome ?? completedPayload.establishment_name,
    is_special_prescription: prescription.RequerReceituarioEspecial ?? false,
    is_digital_sign_mandatory: isDigitalSignMandatory,
    is_pdf_customized: isPdfCustomized,
    is_personal_number_sent: isPersonalNumberSent,
  };
}
